export enum FederalIdType {
    Physical = 'Physical',
    Juridical = 'Juridical'
}
